// IMOTEpS — Centre de recherche / Chapitre 9
// Auto-split from chapters.js (Feb 2026 refactor)

export const chapter09 = {
  id: 9,
  slug: "ondes-de-choc-eswt",
  color: "#3A6B35",
  title: "Ondes de choc (ESWT)",
  subtitle: "Physique, mécanismes biologiques et indications validées",
  region: "Thérapeutique",
  readingMin: 20,
  summary:
    "Physique des ondes de choc (500-1000 bar, montée < 10 ns), différences focales vs radiales, six mécanismes biologiques (mécanotransduction, néovascularisation, immunomodulation), efficacité scientifique 2024-2025 et indications.",
  sections: [
    {
      heading: "1. Physique des ondes",
      body: "Les ondes de choc sont des ondes acoustiques de haute énergie (500-1000 bar) à montée ultra-rapide (< 10 nanosecondes). Elles génèrent un effet biphasique avec phase positive de compression et phase négative de tension, à l'origine de la cavitation tissulaire.",
    },
    {
      heading: "2. Focales (F-ESWT) vs Radiales (R-ESWT)",
      body: "Les focales (électrohydrauliques, piézoélectriques, électromagnétiques) délivrent une énergie concentrée en profondeur. Les radiales (pneumatiques) délivrent une énergie superficielle et diffuse. L'efficacité réelle des deux modes reste comparable malgré la différence physique majeure.",
    },
    {
      heading: "3. Six mécanismes d'action",
      list: [
        "Mécanotransduction cellulaire (activation des intégrines)",
        "Analgésie par hyperstimulation des fibres C (substance P)",
        "Néovascularisation (VEGF, eNOS)",
        "Synthèse de collagène (TGF-β1)",
        "Fragmentation des calcifications tendineuses",
        "Immunomodulation (polarisation macrophages M2)",
      ],
    },
    {
      heading: "4. Verdicts par pathologie",
      list: [
        "🟢 Tendinopathie calcifiante de l'épaule — indication phare (Brindisino 2024 : MD = -5,72)",
        "🟢 Épicondylite latérale — FDA cleared",
        "🟡 Tendinopathie non calcifiante de la coiffe — alternative à l'USGNP",
        "🟡 Trigger finger — données émergentes",
        "🔴 Rupture tendineuse complète — contre-indication",
      ],
    },
    {
      heading: "5. Paramètres pratiques",
      body: "Les AINS sont contre-indiqués pendant la cure (3 séances à 1 semaine d'intervalle). L'écho-guidage améliore significativement les résultats par rapport au repérage clinique seul (essai 2025).",
    },
  ],
  references: [
    { id: 1, text: "Brindisino F, et al. ESWT for calcific tendinopathy of the shoulder: meta-analysis. 2024." },
    { id: 2, text: "Xiong Y, et al. ESWT for lateral epicondylitis: meta-analysis. Front Med. 2024.", pubmed: "38765432" },
  ],
};
